import { mdiClipboardAccountOutline } from '@mdi/js'

export default {
  title: 'Hod',
  to: 'hod-list',
  icon: mdiClipboardAccountOutline,
  resource: 'HodAdmin',
  action: 'read',
}
